import { useState, useEffect } from 'preact/hooks'

import { Typography } from 'components/UI'

type ReSendTimerButtonProps = {
	/** A callback to be invoked once the countdown finishes (timer reaches 0). */
	onDisplayRecommendations: () => void
}

// Initial countdown (in seconds).
const WAITING_TIME_TO_SEND_EMAIL = 30

/**
 * Displays a countdown from {@link WAITING_TIME_TO_SEND_EMAIL} to 0.
 * When the countdown ends, calls `onDisplayRecommendations()` so the
 * parent can show further instructions instead of continuing the countdown.
 */
const CountdownText = ({
	onDisplayRecommendations
}: ReSendTimerButtonProps) => {
	const [timer, setTimer] = useState(WAITING_TIME_TO_SEND_EMAIL)

	// Count down effect
	useEffect(() => {
		if (timer <= 0) {
			onDisplayRecommendations()
			return
		}

		const intervalId = setInterval(() => {
			setTimer(t => t - 1)
		}, 1000)

		// eslint-disable-next-line consistent-return
		return () => clearInterval(intervalId)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [timer])

	const buttonText = `Try again in ${timer} seconds`

	return (
		<Typography
			class='mt-6'
			color='text-black-200'
			text={buttonText}
			variant='text3'
		/>
	)
}

export { CountdownText }
